import {RemotePostContractualTermAccept} from 'data/usecases/private/home/remote-post-contractual-term-accept';
import {PostContractualTermAccept} from 'domain/usecases/private/home/post-contractual-term-accept';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {HomeEndPoints} from 'main/factories/usecases/endpoints';

export const makePostContractualTermAccept = (): PostContractualTermAccept =>
	new RemotePostContractualTermAccept(
		makeBFFApiUrl(HomeEndPoints.contractualTermAccept),
		makeAuthorizeHttpClientDecorator(),
	);
